module.exports = __webpack_public_path__ + "media/chatsound.590bf331.mp3";